import { render, staticRenderFns } from "./ad-product-page-title.vue?vue&type=template&id=28502250"
import script from "./ad-product-page-title.vue?vue&type=script&lang=ts"
export * from "./ad-product-page-title.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports